import button from './button';
import input from './input';
import table from './table';

export default {
  ...table,
  ...button,
  ...input,
};
